/* tslint:disable */
/* eslint-disable */

/**
 * Type of discount: percentage-based or fixed CHF amount
 */
export enum WorkCalculationitemDiscountTypeEnum {
  Percentage = 'percentage',
  Fixed = 'fixed'
}
